module.exports = __webpack_public_path__ + "static/dhd-favicon-114-9362527e1ffa68a87f2a65f5f6ec476d.png";